import { Stack } from "@mui/material";
import { SelectElement, SwitchElement, TextFieldElement } from "react-hook-form-mui";
import { useTranslation } from "react-i18next";

import { questionTypeOptions } from "../../config/questionTypeOptions";

export default function QuestionCoreFields() {
    const { t } = useTranslation("formTemplateEditor");

    return (
        <>
            <Stack direction="row" columnGap={2} alignItems="stretch">
                <TextFieldElement
                    name="name"
                    label={t("formTemplateQuestionForm.labelName")}
                    required
                    sx={{ flex: 2 }}
                />
                <SelectElement
                    name="type.__typename"
                    label={t("formTemplateQuestionForm.labelType")}
                    options={questionTypeOptions.map(option => ({
                        id: option.id,
                        label: (
                            <Stack direction="row" columnGap={1} alignItems="center">
                                {option.icon}
                                {t(option.translationKey)}
                            </Stack>
                        ),
                    }))}
                    required
                    variant="filled"
                    sx={{ flex: 1 }}
                />
            </Stack>
            <SwitchElement name="isRequired" label={t("formTemplateQuestionForm.labelRequired")} />
            <SwitchElement name="showToClientUser" label={t("formTemplateQuestionForm.labelShowToClientUser")} />
        </>
    );
}
